module.exports = __webpack_public_path__ + "e604dc1e8afa4ddafb49e2445c61a448.png";